import { render, staticRenderFns } from "@/modules/Newcase/templates/case-detail.html?vue&type=template&id=1ed885ad&scoped=true&"
import script from "@/modules/Newcase/scripts/case-detail.ts?vue&type=script&lang=js&"
export * from "@/modules/Newcase/scripts/case-detail.ts?vue&type=script&lang=js&"
import style0 from "@/modules/Newcase/styles/case-detail.scss?vue&type=style&index=0&id=1ed885ad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed885ad",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
